import { render, staticRenderFns } from "./PurchasesOrderViewDetails.vue?vue&type=template&id=466c3ce2"
import script from "./PurchasesOrderViewDetails.vue?vue&type=script&lang=js"
export * from "./PurchasesOrderViewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports